import React from "react";
import { BiCheck } from "react-icons/bi";
import "./Secvices.css";

const Secvices = () => {
  return (
    <section id="services">
      <h5>What I Offer</h5>
      <h2>Catalog</h2>
      <div className="container services__container">
        <article className="service">
          <div className="service__head">
            <h3>Machine Learning and AI</h3>
          </div>
          <ul className="service__list">
            <li>
              <BiCheck className="service__list-icon" />
              <p>Cutting-edge facial recognition model development.</p>
            </li>

            <li>
              <BiCheck className="service__list-icon" />
              <p>Sophisticated poster detection algorithm creation.</p>
            </li>

            <li>
              <BiCheck className="service__list-icon" />
              <p>Advanced movie recommendation system implementation.</p>
            </li>

            <li>
              <BiCheck className="service__list-icon" />
              <p>Data analytics utilized for insightful analysis.</p>
            </li>

            <li>
              <BiCheck className="service__list-icon" />
              <p>
                Transformer models developed for Hindi to English translation.
              </p>
            </li>

            <li>
              <BiCheck className="service__list-icon" />
              <p>
                NLM and Helsinki FineTuned technologies leveraged for
                translation.
              </p>
            </li>

            <li>
              <BiCheck className="service__list-icon" />
              <p>Text extraction models developed from images and memes.</p>
            </li>

            <li>
              <BiCheck className="service__list-icon" />
              <p>NLP used for sentiment analysis and hate speech detection.</p>
            </li>

            <li>
              <BiCheck className="service__list-icon" />
              <p>Sophisticated algorithms alert users of hate speech.</p>
            </li>
          </ul>
        </article>

        {/* end of ML / AI */}

        <article className="service">
          <div className="service__head">
            <h3>Web Development</h3>
          </div>
          <ul className="service__list">
            <li>
              <BiCheck className="service__list-icon" />
              <p>Visually appealing and user-friendly websites</p>
            </li>

            <li>
              <BiCheck className="service__list-icon" />
              <p>Responsive design for multi-device compatibility</p>
            </li>

            <li>
              <BiCheck className="service__list-icon" />
              <p>Integration of third-party APIs and services</p>
            </li>

            <li>
              <BiCheck className="service__list-icon" />
              <p>Cross-browser compatibility and accessibility</p>
            </li>

            <li>
              <BiCheck className="service__list-icon" />
              <p>Interactive and engaging user interfaces</p>
            </li>

            <li>
              <BiCheck className="service__list-icon" />
              <p>Utilized React Context and Redux for state management</p>
            </li>

            <li>
              <BiCheck className="service__list-icon" />
              <p>Developed full-stack applications using the MERN stack</p>
            </li>

            <li>
              <BiCheck className="service__list-icon" />
              <p>Built RESTful APIs for seamless data communication</p>
            </li>

            <li>
              <BiCheck className="service__list-icon" />
              <p>Deployed applications to cloud platforms for scalability</p>
            </li>
          </ul>
        </article>

        {/* end of UI */}

        <article className="service">
          <div className="service__head">
            <h3>App Development</h3>
          </div>
          <ul className="service__list">
            <li>
              <BiCheck className="service__list-icon" />
              <p>Native app dev for both iOS and Android.</p>
            </li>

            <li>
              <BiCheck className="service__list-icon" />
              <p>User-friendly interface design and optimization.</p>
            </li>

            <li>
              <BiCheck className="service__list-icon" />
              <p>Backend integration and API utilization.</p>
            </li>

            <li>
              <BiCheck className="service__list-icon" />
              <p>Data storage, synchronization, and security implementation.</p>
            </li>

            <li>
              <BiCheck className="service__list-icon" />
              <p>Push notifications and in-app messaging integration.</p>
            </li>

            <li>
              <BiCheck className="service__list-icon" />
              <p>State management with Bloc, GetX, or similar libraries.</p>
            </li>

            <li>
              <BiCheck className="service__list-icon" />
              <p>Socket.IO for real-time chat app development.</p>
            </li>

            <li>
              <BiCheck className="service__list-icon" />
              <p>Firebase for backend and database management.</p>
            </li>

            <li>
              <BiCheck className="service__list-icon" />
              <p>Notification feature implementation using Socket.IO.</p>
            </li>

            <li>
              <BiCheck className="service__list-icon" />
              <p>
                Utilization of pub.dev libraries for enhanced functionality.
              </p>
            </li>
          </ul>
        </article>

        {/* end of UI */}
      </div>
    </section>
  );
};

export default Secvices;
